<div class="input">
  <button nz-button (click)="openChooseFile()"><i nz-icon nzType="upload"></i>{{ textButton }}</button>
  <span>{{ filename || placeholder }}</span>
  <input #38fn57dfjek3 id="38fn57dfjek3" type="file" [accept]="accept" (change)="onChange($event)" />
</div>
